import domPurify from 'dompurify';

export const StringUtilService = {
    sanitizeHtml(html) {
        return domPurify.sanitize(html);
    },

    padWithZero(str) {
        return String(str).padStart(2, '0');
    },

    /**
     * Decode HTML entity to symbol. For example &pound; to £
     * @param html
     * @return {string}
     */
    decodeHtmlEntity(html) {
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    },

    /**
     * Capitalize first letter of a word. For example capitalize to Capitalize
     * @param string
     * @return {string}
     */
    capitalize (string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    },

    stringToKebabCase(title) {
        return title.toLowerCase().replaceAll(' ', '-');
    },

    replaceAll(str, find, replace) {
        const strToReplace = str || '';
        return strToReplace.replace(new RegExp(this.escapeRegExp(find), 'g'), replace);
    },

    escapeRegExp(str) {
        // eslint-disable-next-line no-useless-escape
        return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1');
    },

    stringify(obj) {
        if (obj === null) { return 'null'; }
        if (typeof obj !== 'object') { return String(obj); }

        if (Array.isArray(obj)) {
            return '[' + obj.map(this.stringify).join(',') + ']';
        }

        const keys = Object.keys(obj).sort((a, b) => a.localeCompare(b));
        return keys.map(key => key + ':' + this.stringify(obj[key])).join('|');
    }
};
